define('models/feedback',[
  "backbone",
  "moment"
], function (Backbone, moment) {
  "use strict";

  return Backbone.Model.extend({
    idAttribute: "_id",

    parse: function (response) {
      return _.extend(response, {
        url: response.library + "/" + response.path
      });
    },

    comparator: function (other) {
      return other.get("created") * -1;
    },

    toFormattedJSON: function () {
      var json = this.toJSON(), rating = this.get("rating");

      json.author = json.author || { name: Messages("anonymous") };
      json.created = moment(new Date(json.created)).fromNow();
      json.type = rating > 0 ? "positive" : rating < 0 ? "negative" : "neutral";

      return json;
    }
  });
});

